import React from "react";
import "../../Styles/yellowcalf.css/Payment_Details.css";

function PaymentDetails() {
  return (
    <div className="payment-details-container" style={{ paddingTop: "25px" }}>
      <div className="payment-details-title-row">
        <div className="payment-details-col-12">
          <div className="payment-details-title-panel">
            <div className="payment-details-title-body">
              <h3 className="payment-details-main-title">Payment Details</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="payment-details-content-row">
        <div className="payment-details-col-12">
          <div className="payment-details-content-panel">

            <div className="payment-details-content-body">
              <table className="payment-details-table">
                <tbody>
                  <tr>
                    <th>Amount</th>
                    <td>$ 2700</td>
                  </tr>
                  <tr>
                    <th>Payment Identification Number</th>
                    <td>877_73554</td>
                  </tr>
                  <tr>
                    <th>Payment Type</th>
                    <td>service</td>
                  </tr>
                  <tr>
                    <th>Payment Mode</th>
                    <td>paytm</td>
                  </tr>
                  <tr>
                    <th>Payment Date</th>
                    <td>2022-04-20</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentDetails;
